import React from 'react';
import {
    useHistory
  } from "react-router-dom";
  
  function CompanyBadges(props)  {

    const data = 
      {
      "id": 1,
      "name": "Favorite BBQ",
      "street": "123 Main St.",
      "city": "Sandy Springs",
      "state": "Georgia",
      "badges": 
      [        
        {
            "id": 1,
            "name": "I love Favorite BBQ",
            "price": 5,
            "logo": "/badge1.png",
            "selected": false
        },
        {
            "id": 2,
            "name": "Can't wait to get back to Favorite BBQ",
            "price": 5,
            "logo": "/badge2.png",
            "selected": false
        },
        {
            "id": 3,
            "name": "Favorite BBQ Super Fan!",
            "price": 20,
            "logo": "/badge3.png",
            "selected": false
        },

      ]
    }
    ;

    let history = useHistory();

    function checkout()
    {
      history.push("/checkout");
    }

    const selection =data.badges;
  
    let list = props.list;
    let setList = props.setList;

    if (props.list==0)
    {
        setList(data.badges); 
    }

    return <div className="row">
            <div className="col">
                <div className="container">
                    <div className="row">
                        <div className="col">{data.name} of {data.city}, {data.state}</div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="container">
                                <BadgeList data={list} setList={setList} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="container"> 
                                <SelectionList data={list} checkout={checkout} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ;
  }

  function BadgeList(props) {
    
    const selection = props.data;
    const setList = props.setList;

    //const [setList] = React.useState(selection);

    const addItem = id =>
    {
        setList(
            selection.map(item => {
              if (item.id === id) {
                return { ...item, selected: !item.selected };
              } else {
                return item;
              }
            })
        );
    }
  
      return selection.map((node, index) => {

        const id = node.id;

        var selected = "no";
        if (node.selected) { selected = "yes" } 

        return <div className="row" key={node.id}>
          <div className="col col-sm-2"><img className="img-fluid" src={node.logo} alt={node.name}/></div>
          <div className="col col-sm-5">{node.name}</div>
          <div className="d-none d-sm-block col-2 col-sm-3">${node.price}</div>
          <div className="col col-sm-2 col-md-2 col-lg-2">
                <div className="d-block d-sm-none lg-none xl-none">${node.price}</div>
                { node.selected &&
                 <input type="image" src="/selected.png" onClick={() => addItem(id)}/>
                }
                { !node.selected &&                
                 <input type="image" src="/unselected.png" onClick={() => addItem(id)}/>
                }
              </div>
        </div>
      })
    
  }

  function SelectionList(props)
  {

      const selection = props.data;
      const checkout = props.checkout;

      const selected = selection.filter(item => item.selected === true);

      var total = 0;

      selected.map(item => (total = total + item.price));

      return (
        <div>
            <div className="row">
                <div className="col-4">Your order: {selected.length } badge(s), ${total} total </div>
                { selected.length > 0 &&
                <div className="col-6">Checkout now <input type="image" src="/go-button.png" onClick={checkout}/></div>
                }
            </div>
        </div>
      );
  }

 
  export default CompanyBadges;


